import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_LogTemplate, defaultItem_LogTemplate } from '@app/advisor-content-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_LogTemplate } from '../../../_entity/log-tempalte/ModuleFE_LogTemplate.js';
import { Renderer_LogTemplateHeader } from './renderers/Renderer_LogTemplateHeader/Renderer_LogTemplateHeader.js';
import { Editor_LogTemplate } from '../../editors/Editor_LogTemplate/Editor_LogTemplate.js';
import './Manager_LogTemplate.scss';
import { LL_V_L } from "@nu-art/thunderstorm-frontend/index";
const Editor_LogTemplate_Wrapper = (props) => _jsxs(LL_V_L, { className: 'manager-log-template', children: [_jsx(Renderer_LogTemplateHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_LogTemplate, { editable: props.editable, editMode: props.renderArgs.editMode, hideHeader: true })] });
export const Manager_LogTemplate = createWorkHubManager({
    module: ModuleFE_LogTemplate,
    dbDef: DBDef_LogTemplate,
    defaultItem: defaultItem_LogTemplate,
    labelResolver: (logTemplate) => logTemplate.label ?? "New Log Template",
    EditorComponent: Editor_LogTemplate_Wrapper,
});
//# sourceMappingURL=Manager_LogTemplate.js.map